import React, { SVGProps } from 'react';
type Props = {} & SVGProps<SVGSVGElement>;
export default function IcDocument(props: Props) {
    return (
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M13.167 5.3335C14.2716 5.3335 15.167 4.43807 15.167 3.3335C15.167 2.22893 14.2716 1.3335 13.167 1.3335C12.0624 1.3335 11.167 2.22893 11.167 3.3335C11.167 4.43807 12.0624 5.3335 13.167 5.3335Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M5.16699 8.6665H8.50033" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.16699 11.3335H11.167" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M9.8335 1.3335H6.50016C3.16683 1.3335 1.8335 2.66683 1.8335 6.00016V10.0002C1.8335 13.3335 3.16683 14.6668 6.50016 14.6668H10.5002C13.8335 14.6668 15.1668 13.3335 15.1668 10.0002V6.66683"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
